module.exports = __webpack_public_path__ + "static/media/planning1@2x.c276b89d.png";